import React, { Fragment, memo } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Notification from '../../components/notification/Notification';
import HeaderLogo from '../../layout-components/HeaderLogo';
import HeaderUserbox from '../../layout-components/HeaderUserbox';
import HeaderMenuSimple from '../../layout-components/HeaderMenuSimple';
import GloballyCompanySearch from '../../components/watchlist/GloballyCompanySearch';
import wrapWithErrorBoundary from 'global/ErrorBoundary';
import { HEADER_HEIGHT } from 'config/appConfig';
import { Hidden, makeStyles } from '@material-ui/core';
import CompaniesDataLoading from './CompaniesDataLoading';

const Header = () => {
  const classes = useStyles();

  return (
    <Fragment>
      <AppBar className={classes.appBar} color="secondary" position="fixed" elevation={11}>
        <HeaderLogo />
        <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Hidden smDown>{wrapWithErrorBoundary(<HeaderMenuSimple />)}</Hidden>
          </Box>
          <CompaniesDataLoading />
          <Box display="flex" alignItems="center">
            {wrapWithErrorBoundary(<GloballyCompanySearch />)}
            {wrapWithErrorBoundary(<Notification />)}
            {wrapWithErrorBoundary(<HeaderUserbox />)}
          </Box>
        </Box>
      </AppBar>
    </Fragment>
  );
};

export default memo(Header);

const useStyles = makeStyles({
  appBar: {
    height: HEADER_HEIGHT,
    display: 'flex',
    flexDirection: 'row',
    '& button:hover': { backgroundColor: 'rgba(255, 255, 255, 0.07)' },
  },
});
